var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 308,
    viewBox: "0 0 422 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4369_2879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3281 183.097C85.1877 182.184 94.1528 179.231 127.933 170.174C169.964 158.906 201.652 171.882 213.522 177.547C243.092 191.661 259.461 180.877 280.7 177.957C291.877 176.42 231.01 229.586 163.515 245.69C138.577 251.64 47.2044 273.44 -0.998493 254.468V169.502C15.4856 169.456 29.4275 185.204 68.3256 183.099L68.3281 183.097Z",
    fill: "#84C7D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78 212.291C157.26 199.095 191.076 194.473 218.896 190.671C232.805 188.77 237.422 188.861 260.296 180.58C270.321 176.952 319.081 152.73 363.229 155.268C394.404 157.059 412.321 171.014 422.847 183.19V272.512H166.8C147.304 251.349 136.059 225.789 146.78 212.291Z",
    fill: "#5BB4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.996152 231.103C16.5686 228.849 32.3194 222.72 51.7391 218.735C114.878 205.777 156.117 219.311 181.183 225.541C219.281 235.009 381.948 236.048 422.847 271.894L422.845 307.742H-0.999782L-0.997362 224.01L-0.996152 231.103Z",
    fill: "#33B986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.549 0C405.664 0.851338 415.039 4.3322 423 9.76562V106.49C413.776 112.785 402.656 116.462 390.685 116.462C358.778 116.462 332.912 90.3445 332.912 58.1279C332.912 27.5654 356.19 2.49378 385.822 0H395.549Z",
    fill: "#FFFCCA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4369_2879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 308,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackground);
export default __webpack_public_path__ + "static/media/card-background.64de24fa1c387f1bd78fd719f95ae8e5.svg";
export { ForwardRef as ReactComponent };